var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "head"
  }, [_vm.initConfig.urlInfo && _vm.initConfig.urlInfo.userAuth ? _c('tvu-top-header', {
    attrs: {
      "projectName": _vm.initConfig.serverName,
      "globalFunList": ['waffle', 'account'],
      "versionServiceNameList": [_vm.initConfig.serverName]
    },
    on: {
      "callback": _vm.topHeaderCallback
    },
    scopedSlots: _vm._u([{
      key: "right-app-module",
      fn: function () {
        return [_c('div', {
          staticClass: "item-fun"
        }, [_c('HeaderTime')], 1)];
      },
      proxy: true
    }], null, false, 3562305163)
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };